import gql from 'graphql-tag';

const SAVE_PERSONALIZATION = gql`
  mutation($user: UserInput, $category: String, $name: String, $value: String) {
    savePersonalization(
      input: { user: $user, category: $category, name: $name, value: $value }
    )
  }
`;

const GET_PERSONALIZATION_BY_NAME = gql`
  query($userId: ID!, $category: String!, $name: String!) {
    getPersonalizationByCategoryAndName(
      userId: $userId
      category: $category
      name: $name
    ) {
      name
      category
      value
    }
  }
`;

const GENERATE_API_TOKEN = gql`
  mutation {
    generateAPIToken
  }
`;

const GET_API_TOKEN = gql`
  query {
    getAPIToken
  }
`;

const GET_USERTERMINAL_WSSTOKEN = gql`
  query {
    populateUserTerminalWssToken
  }
`;
const GET_PLAN_FEATURE = gql`
  query {
    getPlanFeaturesState
  }
`;

const GET_PLAN_PRODUCT_FEATURES = gql`
  query {
    getPlanProductFeatures {
      planProductFeatureId
      feature {
        featureId
        name
        labelKey
        releaseState
      }
      available
      availableWithAddOn
      enabled
      upsell
      upsellPlanId
      upsellAddonId
    }
  }
`;

const GET_PLAN_FEATURE_GATING = gql`
  query {
    getFeatureGatingInfo
  }
`;

export {
  SAVE_PERSONALIZATION,
  GET_PERSONALIZATION_BY_NAME,
  GENERATE_API_TOKEN,
  GET_USERTERMINAL_WSSTOKEN,
  GET_API_TOKEN,
  GET_PLAN_FEATURE,
  GET_PLAN_PRODUCT_FEATURES,
  GET_PLAN_FEATURE_GATING
};
